import { useState } from "react";
import { validateLocation } from "../utils";
import axios from "axios";

import CONFIG from '../config.json';
import { useCookies } from "react-cookie";
import { Locations, Location } from "../ui";
import { Label } from "../components/Label";

export const useDeleteLogic = () => {

    const [locationDeleteField, setLocationField] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [data, setData] = useState<{ location: string, eans: string[] }>();

    const [cookie, setCookie, removeCookie] = useCookies(['access_key']);

    const removePalletLocation = () => {
        if (!validateField()) {
            setData(undefined);
            return;
        }
        axios.delete(CONFIG.API, { params: { location: locationDeleteField, accessKey: cookie.access_key } }).then((res) => {
            setData({
                eans: res.data.eans,
                location: res.data.location
            });
            setErrorMessage('');
        }).catch((err) => {
            if (!err.response) {
                setErrorMessage('Server error, try again');
                return;
            }
            setErrorMessage(err.response.data.message);
            setData(undefined);
        });
    }

    const validateField = () => {
        if (!validateLocation(locationDeleteField)) {
            setErrorMessage('Podaj lokalizację w prawidłowym formacie');
            return false;
        }
        return true;
    }

    const showData = () => {
        if (!data) return;
        return (
            <>
                <Label>{data.location}</Label>
                <Locations>{data.eans.map((ean, index) => <Location key={index}>{ean}</Location>)}</Locations>
            </>
        )
    }

    return { setLocationField, errorMessage, data, removePalletLocation, showData }
}